
import CryptoJS from 'crypto-js';

export function encryptAPI(msg, passPhrase) {
  return CryptoJS.AES.encrypt(msg, passPhrase).toString();
}

export function decryptAPI(msg, passPhrase) {
  return CryptoJS.AES.decrypt(msg, passPhrase).toString(CryptoJS.enc.Utf8);
}

export async function encrypt (msg, key) {
    return encryptAPI(msg, key);
    /* used this fall back in the future
    if (!window.crypto.subtle) {
        return encryptAPI(msg, key);
    }
    const encodedData = new TextEncoder().encode(msg);
    // favor use of native 
    const options = {
        name: "AES-GCM",
        iv: new Uint8Array(12),
    };
    const encryptedData = await window.crypto.subtle.encrypt(options, key, encodedData);
    return encryptedData;
    */
}

export async function decrypt(encryptedMSG, key) {
    return decryptAPI(encryptedMSG, key);
    /*
    Use this fallback in the future.
    if (!window.crypto.subtle) {
        return decryptAPI(encryptedMSG, key);
    }

    const option = {
        name: "AES-GCM",
        iv: new Uint8Array(12),
    };

    const decryptedData = await window.crypto.subtle.decrypt(
        option,
        key,
        encryptedMSG
    );

    return new TextDecoder().decode(decryptedData);
    */
}

// erase later
export async function encryptTest () {
    const msg = 'http://localhost:3030/button/v1/ecal.html?_=1723686383116&widgetRef=HOPTGTOFd8VvGniFyTmFWdToYlARFcbihJs5BCE620b90007ff&apiKey=HOPTGTOFd8VvGniFyTmFWdToYlARFcbihJs5BCE620b90007ff&docReferrer=https%3A%2F%2Fwww.linkedin.com%2F&clientOrigin=http%3A%2F%2Flocalhost%3A3030&k=HOPTGTOFd8VvGniFyTmFWdToYlARFcbihJs5BCE620b90007ff&d=APP_STORAGE';
    const key = 'HOPTGTOFd8VvGniFyTmFWdToYlARFcbihJs5BCE620b90007ff';
    const encrypted = await encrypt(msg, key);
    console.log('encryptTest() encrypted: ', encrypted);

    const decrypted = await decrypt(encrypted, key);
    console.log('encryptTest() decrypted: ', decrypted);

    const src = 'U2FsdGVkX1++KtdRX4NXSq/VTFKhBjqXjAoUrT/2ryp3mB/qXJuxOdgPY2anZUn3v+p38bwJCOMvZ1zNUIcjLj0MN0/wh/YDWg9ThRYxJ5xZqi1kokt6NLBwLhpVnZdFN5eSnK1Y8FAx9Tjwcl8YUDxkWqrC30ZMbG4fqosdH0x0HbmGLtWk9a3mfRcr9rz5XpD/MsYaAlORd3gnKiDDPamgqyuW7m53DxDEdPVsDKm14cViodO/9L1UzFyGuuXcZWKfp064SFkO5KZXVjdV8SONRoYNd9lYY2JaVgbV4HfGUvuMryFG5+YnphurmDjmHvShxMknfpqa63v+06NX7ZT+tETtBAeVp8Mhyo/mmTig5hbTEnZq17XIoK4UQP4q+DetqL173WxGkrBoAzC7DccoZzqh4cuGP3dapmIdmGHI+t7m4KDsigxwCJsyqmgyE21jiaHTccUWBzyAlC1F+ro2DtpaDmki17FgV/e0e4k=';
    const decrypted2 = await decrypt(src, key);
    console.log('encryptTest() decrypted2: ', decrypted2);
}

/*
U2FsdGVkX1+Y8TiSGG6B38095jGqJW04lR1WMEi9ObjXLXeOfPRugwrbyjncGZglt24cTUc/i/4mIVNe2ERI3mVonapOLc1hEjTJSFR0/RHCo4Q++7ioTLQfoqWywiVxtVwQDtvg3xFmGankRfXnkPkd3wx/hL0+W2AqJ0W3lVDOl70eI2X2HLYctCF0e5CG8nTUQZTLeRmDEEf40ujgxmzFRBh5Kk1a5IHW6Q5yPMa9TQN8RcTflsRuYH1vr4t6WbSc+4DF2Fw1hF9Q8kphEP7fm8wzspEsMw0+lVFtor4n00D5SE+vgH5GWF9lvCPN0LuPO55+WIYb0/8mMrA6PEbRqmgYJmyje7wiEnqjkCC5ge99oKYyax5MzIBfAOAJwX8yH3CsLclslJBf04ciCfkB2jlSrR5DLHO/50mNbi/2xP7Sm1pY/w/K3kx4D6V+hbo0UOMe4HoKVdZ5LufwNVC5vuXcyld2nmm+2TN2Tzc=
U2FsdGVkX1++KtdRX4NXSq/VTFKhBjqXjAoUrT/2ryp3mB/qXJuxOdgPY2anZUn3v+p38bwJCOMvZ1zNUIcjLj0MN0/wh/YDWg9ThRYxJ5xZqi1kokt6NLBwLhpVnZdFN5eSnK1Y8FAx9Tjwcl8YUDxkWqrC30ZMbG4fqosdH0x0HbmGLtWk9a3mfRcr9rz5XpD/MsYaAlORd3gnKiDDPamgqyuW7m53DxDEdPVsDKm14cViodO/9L1UzFyGuuXcZWKfp064SFkO5KZXVjdV8SONRoYNd9lYY2JaVgbV4HfGUvuMryFG5+YnphurmDjmHvShxMknfpqa63v+06NX7ZT+tETtBAeVp8Mhyo/mmTig5hbTEnZq17XIoK4UQP4q+DetqL173WxGkrBoAzC7DccoZzqh4cuGP3dapmIdmGHI+t7m4KDsigxwCJsyqmgyE21jiaHTccUWBzyAlC1F+ro2DtpaDmki17FgV/e0e4k=
*/
